import { render, staticRenderFns } from "./SingleLayerClusterStyle.vue?vue&type=template&id=a051c816&scoped=true"
import script from "./SingleLayerClusterStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerClusterStyle.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerClusterStyle.vue?vue&type=style&index=0&id=a051c816&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a051c816",
  null
  ,true
)

export default component.exports